export default __webpack_public_path__ + "static/media/Message.34a507ba.svg";